import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import { UserSettingsStore } from '@webapp/shared';

import { environment } from '../../environments/environment';

export const TeamIdHttpInterceptorFn: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const requestUrl = req.url;
  const apiUrl = environment.apiUrl;

  if (!requestUrl.startsWith(apiUrl)) {
    return next(req);
  }

  const userSettings = inject(UserSettingsStore);
  const selectedTeamId = userSettings.selectedTeamId();

  const requestClone = selectedTeamId
    ? req.clone({ headers: req.headers.set('x-team-id', selectedTeamId) })
    : req;

  return next(requestClone);
};
